import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import * as $ from "jquery";


@Directive({
    selector: "[appunwraptag]",
})
export class UnwrapTagDirective implements AfterViewInit {


    constructor(private el: ElementRef) {

    }
    unwrapTag(element) {
        $(element).removeAttr('appunwraptag').unwrap();
    }
    ngAfterViewInit() {
        let nativeElement: HTMLElement = this.el.nativeElement;
        this.unwrapTag(nativeElement);
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_directives/unwrap-tag.directive.ts